import React, { Component } from "react";
import { connect } from "react-redux";
import { getCredits } from "../../../services/api/credits.api";
import "./style.css";
import { CLIENT_ID_SALESFORCE, CLIENT_ID_HUBSPOT } from "../../../constants";
import { FormattedMessage } from "react-intl";

const jsforce = require("jsforce");

class AuthServ extends Component {
  constructor(props) {
    super(props);
    this.state = {
      login: "",
      loading: false,
      error: false,
      success: false,
    };
    this.startOAuth = this.startOAuth.bind(this);
    this.getOAuthUrl = this.getOAuthUrl.bind(this);

    if (!this.props.clientId) throw new Error("Erreur de connexion");
    if (!this.props.redirectUri) throw new Error("Erreur de connexion");

    this.state = {
      clientId: this.props.clientId,
      redirectUri: this.props.redirectUri,
      scopes: this.props.scopes,
      responseType: this.props.responseType,
    };

    this.oauthUrl = this.props.oauthUrl;
    this.startOAuth = this.startOAuth.bind(this);
  }

  getOAuthUrl() {
    let scopes = this.state.scopes;
    if (this.props.text === "Outlook") {
      return `${this.oauthUrl}?client_id=${this.state.clientId}&response_type=${
        this.state.responseType
      }&scope=${scopes.join(" ")}&redirect_uri=${this.state.redirectUri}`;
    }
    if (this.props.type === "gmail") {
      return `${this.oauthUrl}?client_id=${this.state.clientId}&response_type=${
        this.state.responseType
      }&scope=${scopes.join(" ")}&redirect_uri=${encodeURIComponent(
        this.state.redirectUri
      )}&prompt=consent&access_type=offline&response_mode=query`;
    }
    if (this.props.type === "hubspot") {
      return `${this.oauthUrl}?client_id=${this.state.clientId}&response_type=${
        this.state.responseType
      }&scope=${scopes.join(" ")}&redirect_uri=${encodeURIComponent(
        this.state.redirectUri
      )}`;
    }

    // salesforce
    const oauth2 = new jsforce.OAuth2({
      clientId: CLIENT_ID_SALESFORCE,
      redirectUri: this.state.redirectUri,
    });
    return oauth2.getAuthorizationUrl({});
  }

  startOAuth(e) {
    if (e) e.stopPropagation();
    let self = this;
    this.setState({ loading: true });
    let popup = (url, title, w, h) => {
      let left = window.innerWidth / 2 - w / 2;
      let top = window.innerHeight / 2 - h / 2;
      let pop = window.open(
        url,
        title,
        "toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width=" +
          w +
          ", height=" +
          h +
          ", top=" +
          top +
          ", left=" +
          left
      );
      let timer = setInterval(function () {
        let error = localStorage.getItem("loginError");
        if (pop.closed) {
          clearInterval(timer);
          self.setState({
            login: localStorage.getItem("login"),
            loading: false,
          });
          if (localStorage.getItem("login") === "err") {
            let error = localStorage.setItem("loginError");
            if (self.props.onLogin) self.props.onLogin(false, error);
          } else {
            self.setState({ success: true });
            if (self.props.onLogin)
              self.props.onLogin(
                localStorage.getItem("login"),
                error,
                localStorage.getItem("isCrmVerified")
              );
          }
          localStorage.setItem("login", null);
          localStorage.setItem("loginError", null);
        }
      }, 500);
      return pop;
    };
    popup(
      this.getOAuthUrl(),
      `${this.props.text} Sign In`,
      this.props.dim.width,
      this.props.dim.height
    );
  }

  render() {
    if (this.props.type === "gmail")
      return (
        <button onClick={this.startOAuth}>
          <img
            style={{ marginLeft: "-5px", position: "relative", bottom: "10px" }}
            src="/assets/images/btn_google_signin_dark_normal_web.png"
            alt=""
          />{" "}
        </button>
      );
    return (
      <button
        onClick={this.startOAuth}
        className={this.props.inModal ? "btn1 ripple-btn" : "connect-btn"}
      >
        <FormattedMessage id={"settings.profile.connect"} />{" "}
        {this.props.inModal ? (
          <>
            <FormattedMessage id={"settings.to"} />{" "}
            <div className={"capital"}>{this.props.type}</div>{" "}
          </>
        ) : (
          ""
        )}
      </button>
    );
  }
}

export default AuthServ;
